import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faFloppyDisk, faSquare } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { ModalCopiaAnalises } from './styled';
// grade de chips reaproveitada do componente de pontos (mesmo visual)
import { ContainerPontos } from '../pontos/styled';

//APP
import { warningAlert } from '../../../../../../../../../../../../utils/alert';
import type { LabAnaliseItens } from '../../../../../../../../../../../../services/LabAnalises';
import type { AnaliseAdicionada, GeoPointFeature } from '../../../../types';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom';
import { Box } from '../../../../../../../../../../../../Components/CustomUi/box';
import { Select } from '../../../../../../../../../../../../Components/CustomUi/Select';
import { TitleH2 } from '../../../../../../../../../../../../Components/CustomUi/titleH2';

interface Props {
    abrirModalCopia: boolean
    setAbrirModalCopia: (v: boolean) => void
    pontos_selecionados: GeoPointFeature[]
    grupoAnalises: LabAnaliseItens[]
    analises: AnaliseAdicionada[]
    setAnalises: React.Dispatch<React.SetStateAction<AnaliseAdicionada[]>>
}

/** Modal para copiar os pontos de uma análise para outro tipo de análise. */
export function ModalCopiarAnalises({ abrirModalCopia, setAbrirModalCopia, pontos_selecionados, grupoAnalises, analises, setAnalises }: Props) {

    const [openSelect, setOpenSelect] = useState(false)
    const [analiseSelecionada, setAnaliseSelecionada] = useState('')
    const [analiseSelecionadaId, setAnaliseSelecionadaId] = useState<number | null>(null)
    const [cor_selecionada, setCor_selecionada] = useState('')

    const grupoAnalisesTratado = (grupoAnalises ?? []).map((item) => ({
        ...item,
        analise_profundidade_nome: `(${item?.profundidade_nome}) | ${item?.analise_nome}`,
    }))

    /** Códigos já cadastrados, para bloquear a seleção no Select. */
    const analises_ja_adicionadas = (analises ?? []).map((item) => item.cod_analise)

    function selectCor(cod: number) {
        setAnaliseSelecionadaId(cod)
        const filtro = grupoAnalisesTratado.find((item) => item?.cod_analise === cod)
        setCor_selecionada(filtro?.cor ?? '')
    }

    function fechar() {
        setAnaliseSelecionada('')
        setAnaliseSelecionadaId(null)
        setCor_selecionada('')
        setOpenSelect(false)
        setAbrirModalCopia(false)
    }

    function salvarCopia() {
        if (!analiseSelecionadaId) {
            return warningAlert('Selecione um tipo de análise antes de salvar.')
        }
        const analiseOrigem = grupoAnalises?.find((item) => item?.cod_analise === analiseSelecionadaId)
        if (!analiseOrigem) {
            return warningAlert('Análise não encontrada.')
        }
        const jaExiste = analises.some((a) => a?.cod_analise === analiseSelecionadaId)
        if (jaExiste) {
            return warningAlert('Já existe uma análise com esse tipo cadastrada.')
        }

        const novosPontos = pontos_selecionados.map((p) => ({
            ...p,
            COR: analiseOrigem?.cor || p.COR,
        }))
        const valorUnitario = Number(analiseOrigem?.valor) || 0

        const novaAnalise: AnaliseAdicionada = {
            id: Date.now(),
            cod_analise: analiseSelecionadaId,
            pontos_selecionados: novosPontos,
            profundidade: analiseOrigem?.profundidade_nome ?? '',
            analise_nome: analiseOrigem?.analise_nome ?? '',
            valor: analiseOrigem?.valor ?? '',
            cor: analiseOrigem?.cor ?? '',
            valor_analise: (valorUnitario * novosPontos.length).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
            }),
        }

        setAnalises((prev) => [...prev, novaAnalise])
        fechar()
    }

    return (
        <ModalCopiaAnalises open={abrirModalCopia} onCancel={fechar} title='' closeIcon={false} footer={false}>
            <div className='titulo__modal'>
                <TitleH2>Copiar análise</TitleH2>
                <FontAwesomeIcon icon={faClose} onClick={fechar} style={{ cursor: 'pointer' }} />
            </div>
            <div className='body__modal'>
                <Select
                    label='Tipo de análise'
                    value={analiseSelecionada}
                    icon={faSquare}
                    onChange={setAnaliseSelecionada}
                    onChangeID={(id) => selectCor(id as number)}
                    open={openSelect}
                    trigger={setOpenSelect}
                    items={grupoAnalisesTratado}
                    descricaoItem='analise_profundidade_nome'
                    idItem='cod_analise'
                    cor={cor_selecionada}
                    extraItem='cor'
                    disabledItens={analises_ja_adicionadas}
                />
                <Box style={{ marginTop: 10 }}>
                    <ContainerPontos>
                        <h3 className='points-title'>Pontos ({pontos_selecionados?.length || 0})</h3>
                        <div className='points-grid'>
                            {pontos_selecionados?.map((point, index) => (
                                <div key={index} className='point-card' style={{ backgroundColor: cor_selecionada || point?.COR || '#ccc' }}>
                                    {point?.NOME?.toString().padStart(2, '0')}
                                </div>
                            ))}
                        </div>
                    </ContainerPontos>
                </Box>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                    <ButtonCustom onClick={salvarCopia} icon={<FontAwesomeIcon icon={faFloppyDisk} />}>
                        Copiar
                    </ButtonCustom>
                </div>
            </div>
        </ModalCopiaAnalises>
    )
}
